export default __webpack_public_path__ + "images/SY.7e01467.png";